import type { EmployeeYearInReview } from '@/types';
import { EmployeeTrainingStatus } from '@/types/employee';

// Constants
import { FALLBACK_SRC } from '@shared/constants';

export const mockEmployeeYearInReview = {
  id: 'jane.smith@example.com',
  year: 2025,
  openingSentence: 'a year of\nimpact\nand\nachievement',
  employee: {
    info: {
      name: 'Jane Smith',
      avatar: FALLBACK_SRC.AVATAR,
      onboardedAt: '2020-09-15',

      title: 'Backend Developer',
    },
    certs: [
      {
        name: 'Ultimate AWS Certified Cloud Practitioner AWS',
        org: 'Amazon Web Services',
        issue: '2025-03-17T00:00:00.000Z',
        url: 'https://example.com/aws-cert',
      },
      {
        name: 'Google Cloud Professional Cloud Architect',
        org: 'Google Cloud',
        issue: '2025-05-20T00:00:00.000Z',
        url: 'https://example.com/gcp-cert',
      },
      {
        name: 'Kubernetes Application Developer (CKAD)',
        org: 'The Linux Foundation',
        issue: '2025-07-15T00:00:00.000Z',
        url: 'https://example.com/ckad-cert',
      },
      {
        name: 'Microsoft Azure Administrator Certified Associate',
        org: 'Microsoft',
        issue: '2025-08-30T00:00:00.000Z',
        url: 'https://example.com/azure-cert',
      },
      {
        name: 'HashiCorp Certified: Terraform Associate',
        org: 'HashiCorp',
        issue: '2025-09-25T00:00:00.000Z',
        url: 'https://example.com/terraform-cert',
      },
      {
        name: 'MongoDB Certified Associate Developer',
        org: 'MongoDB, Inc.',
        issue: '2025-10-28T00:00:00.000Z',
        url: 'https://example.com/mongodb-cert',
      },
    ],
  },
  monthsOnProject: 12,
  projects: [
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR1',
      code: 'project-alpha',
      name: 'Project Alpha',
      joinedAt: '2025-01-15T00:00:00.000Z',
      leftAt: '2025-03-31T00:00:00.000Z',
      role: 'Backend Developer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR2',
      code: 'project-beta',
      name: 'Project Beta',
      joinedAt: '2025-04-01T00:00:00.000Z',
      leftAt: '2025-06-30T00:00:00.000Z',
      role: 'Tech Lead',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR3',
      code: 'project-gamma',
      name: 'Project Gamma',
      joinedAt: '2025-05-01T00:00:00.000Z',
      leftAt: '2025-08-31T00:00:00.000Z',
      role: 'Full Stack Developer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR4',
      code: 'project-delta',
      name: 'Project Delta',
      joinedAt: '2025-09-01T00:00:00.000Z',
      leftAt: '2025-12-31T00:00:00.000Z',
      role: 'Frontend Developer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR5',
      code: 'project-epsilon',
      name: 'Project Epsilon',
      joinedAt: '2025-10-01T00:00:00.000Z',
      leftAt: '2025-12-31T00:00:00.000Z',
      role: 'Frontend Developer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR6',
      code: 'project-zeta',
      name: 'Project Zeta',
      joinedAt: '2025-02-01T00:00:00.000Z',
      leftAt: '2025-04-30T00:00:00.000Z',
      role: 'DevOps Engineer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR7',
      code: 'project-eta',
      name: 'Project Eta',
      joinedAt: '2025-03-15T00:00:00.000Z',
      leftAt: '2025-07-15T00:00:00.000Z',
      role: 'Software Architect',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR8',
      code: 'project-theta',
      name: 'Project Theta',
      joinedAt: '2025-06-01T00:00:00.000Z',
      leftAt: '2025-09-30T00:00:00.000Z',
      role: 'QA Engineer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKR9',
      code: 'project-iota',
      name: 'Project Iota',
      joinedAt: '2025-07-01T00:00:00.000Z',
      leftAt: '2025-10-31T00:00:00.000Z',
      role: 'Data Engineer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKRA',
      code: 'project-kappa',
      name: 'Project Kappa',
      joinedAt: '2025-08-15T00:00:00.000Z',
      leftAt: '2025-11-30T00:00:00.000Z',
      role: 'Mobile Developer',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKRB',
      code: 'project-lambda',
      name: 'Project Lambda',
      joinedAt: '2025-09-01T00:00:00.000Z',
      leftAt: '2025-12-15T00:00:00.000Z',
      role: 'Cloud Architect',
    },
    {
      id: '01KG6K5E5YJZ2QHWH278CXMKRC',
      code: 'project-mu',
      name: 'Project Mu',
      joinedAt: '2025-11-01T00:00:00.000Z',
      leftAt: '2025-12-31T00:00:00.000Z',
      role: 'Security Engineer',
    },
  ],
  projectFeedbacks: [
    {
      id: '01KGE5YADP3NM4WA2TMC1RG2SX',
      role: 'TECHNICAL ADVISOR',
      feedbackHighlight:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
      related: 'daniel.thomson@example.com',
      relatedName: 'Daniel Thomson',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      projectId: '01KG6K5E5YJZ2QHWH278CXMKR1',
      projectCode: 'project-alpha',
    },
    {
      id: '01KGE5YADP3NM4WA2TMC1RG2SY',
      role: 'TECHNICAL LEAD',
      feedbackHighlight:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
      related: 'hiyos.kamei@example.com',
      relatedName: 'Hiyos Kamei',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      projectId: '01KG6K5E5YJZ2QHWH278CXMKR2',
      projectCode: 'project-beta',
    },
    {
      id: '01KGE5YADP3NM4WA2TMC1RG2SZ',
      role: 'PROJECT MANAGER',
      feedbackHighlight:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
      related: 'emily.johnson@example.com',
      relatedName: 'Emily Johnson',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      projectId: '01KG6K5E5YJZ2QHWH278CXMKR3',
      projectCode: 'project-gamma',
    },
  ],
  monthsOnTraining: 8,
  trainings: [
    {
      id: 'training-001',
      topicLabel: 'Expo and Github Actions',
      status: EmployeeTrainingStatus.COMPLETED,
      supporters: [
        { name: 'Sarah Wilson', avatar: FALLBACK_SRC.AVATAR },
        { name: 'Mike Chen', avatar: FALLBACK_SRC.AVATAR },
      ],
      start: '2025-02-01T00:00:00.000Z',
      actualEnd: '2025-03-31T00:00:00.000Z',
    },
    {
      id: 'training-002',
      topicLabel: 'Design System Tokens and Motion Guidelines',
      status: EmployeeTrainingStatus.COMPLETED,
      supporters: [{ name: 'Lisa Park', avatar: FALLBACK_SRC.AVATAR }],
      start: '2025-07-01T00:00:00.000Z',
      actualEnd: '2025-08-20T00:00:00.000Z',
    },
    {
      id: 'training-003',
      topicLabel: 'Advanced Performance Tuning for React Apps',
      status: EmployeeTrainingStatus.COMPLETED,
      supporters: [
        { name: 'David Kim', avatar: FALLBACK_SRC.AVATAR },
        { name: 'Maria Rodriguez', avatar: FALLBACK_SRC.AVATAR },
        { name: 'Nina Collins', avatar: FALLBACK_SRC.AVATAR },
      ],
      start: '2025-05-10T00:00:00.000Z',
      actualEnd: '2025-06-25T00:00:00.000Z',
    },
    {
      id: 'training-004',
      topicLabel: 'Leadership for Technical Mentors',
      status: EmployeeTrainingStatus.COMPLETED,
      supporters: [{ name: 'Tom Baker', avatar: FALLBACK_SRC.AVATAR }],
      start: '2025-09-15T00:00:00.000Z',
      actualEnd: '2025-11-15T00:00:00.000Z',
    },
    {
      id: 'training-005',
      topicLabel: 'Cloud Cost Optimization Workshop',
      status: EmployeeTrainingStatus.COMPLETED,
      supporters: [
        { name: 'Alex Morgan', avatar: FALLBACK_SRC.AVATAR },
        { name: 'Emily Foster', avatar: FALLBACK_SRC.AVATAR },
        { name: 'Ryan Mitchell', avatar: FALLBACK_SRC.AVATAR },
        { name: 'Sophie Turner', avatar: FALLBACK_SRC.AVATAR },
      ],
      start: '2025-04-01T00:00:00.000Z',
      actualEnd: '2025-05-05T00:00:00.000Z',
    },
    {
      id: 'training-006',
      topicLabel: 'AI Product Discovery Sprint',
      status: EmployeeTrainingStatus.IN_PROGRESS,
      supporters: [{ name: 'Rina Patel', avatar: FALLBACK_SRC.AVATAR }],
      start: '2025-12-01T00:00:00.000Z',
    },
  ],
  trainingFeedbacks: [
    {
      id: '01TFB5YADP3NM4WA2TMC1RG2T1',
      role: 'TRAINING SUPPORTER',
      feedbackHighlight:
        'Exceptional dedication and quick grasp of complex concepts throughout the training.',
      related: 'sarah.wilson@example.com',
      relatedName: 'Sarah Wilson',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      trainingId: 'training-001',
      topicLabel: 'Expo and Github Actions',
    },
    {
      id: '01TFB5YADP3NM4WA2TMC1RG2T2',
      role: 'TRAINING MENTOR',
      feedbackHighlight:
        'Outstanding progress in design system principles with consistently high-quality work.',
      related: 'lisa.park@example.com',
      relatedName: 'Lisa Park',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      trainingId: 'training-002',
      topicLabel: 'Design System Tokens and Motion Guidelines',
    },
    {
      id: '01TFB5YADP3NM4WA2TMC1RG2T3',
      role: 'TRAINING LEAD',
      feedbackHighlight:
        'Remarkable problem-solving skills, identifying bottlenecks and implementing effective fixes.',
      related: 'david.kim@example.com',
      relatedName: 'David Kim',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      trainingId: 'training-003',
      topicLabel: 'Advanced Performance Tuning for React Apps',
    },
    {
      id: '01TFB5YADP3NM4WA2TMC1RG2T4',
      role: 'TRAINING LEAD',
      feedbackHighlight:
        'Remarkable problem-solving skills, identifying bottlenecks and implementing effective fixes.',
      related: 'david.kim@example.com',
      relatedName: 'David Kim',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      trainingId: 'training-003',
      topicLabel: 'Advanced Performance Tuning for React Apps',
    },
    {
      id: '01TFB5YADP3NM4WA2TMC1RG2T5',
      role: 'TRAINING LEAD',
      feedbackHighlight:
        'Remarkable problem-solving skills, identifying bottlenecks and implementing effective fixes.',
      related: 'david.kim@example.com',
      relatedName: 'David Kim',
      relatedAvatar: FALLBACK_SRC.AVATAR,
      trainingId: 'training-003',
      topicLabel: 'Advanced Performance Tuning for React Apps',
    },
  ],
  mentees: [
    {
      email: 'alice.nguyen@example.com',
      username: 'alice.nguyen',
      name: 'Alice Nguyen',
      avatar: FALLBACK_SRC.AVATAR,
      onboardedAt: '2025-01-10T00:00:00.000Z',
    },
    {
      email: 'brian.le@example.com',
      username: 'brian.le',
      name: 'Brian Le',
      avatar: FALLBACK_SRC.AVATAR,
      onboardedAt: '2025-03-05T00:00:00.000Z',
    },
    {
      email: 'clara.tran@example.com',
      username: 'clara.tran',
      name: 'Clara Tran',
      avatar: FALLBACK_SRC.AVATAR,
      onboardedAt: '2025-05-20T00:00:00.000Z',
    },
    {
      email: 'derek.pham@example.com',
      username: 'derek.pham',
      name: 'Derek Pham',
      avatar: FALLBACK_SRC.AVATAR,
      onboardedAt: '2025-07-15T00:00:00.000Z',
    },
    {
      email: 'emma.vo@example.com',
      username: 'emma.vo',
      name: 'Emma Vo',
      avatar: FALLBACK_SRC.AVATAR,
      onboardedAt: '2025-09-01T00:00:00.000Z',
    },
  ],
  supportees: [
    {
      email: 'frank.hoang@example.com',
      username: 'frank.hoang',
      name: 'Frank Hoang',
      avatar: FALLBACK_SRC.AVATAR,
      trainings: [
        {
          id: 'trainee-training-001',
          topic: 'react-fundamentals',
          topicLabel: 'React Fundamentals',
          start: '2025-02-01T00:00:00.000Z',
        },
        {
          id: 'trainee-training-002',
          topic: 'typescript-basics',
          topicLabel: 'TypeScript Basics',
          start: '2025-04-15T00:00:00.000Z',
        },
      ],
    },
    {
      email: 'grace.do@example.com',
      username: 'grace.do',
      name: 'Grace Do',
      avatar: FALLBACK_SRC.AVATAR,
      trainings: [
        {
          id: 'trainee-training-003',
          topic: 'nextjs-app-router',
          topicLabel: 'Next.js App Router',
          start: '2025-03-10T00:00:00.000Z',
        },
      ],
    },
    {
      email: 'henry.bui@example.com',
      username: 'henry.bui',
      name: 'Henry Bui',
      avatar: FALLBACK_SRC.AVATAR,
      trainings: [
        {
          id: 'trainee-training-004',
          topic: 'docker-containers',
          topicLabel: 'Docker & Containers',
          start: '2025-05-01T00:00:00.000Z',
        },
        {
          id: 'trainee-training-005',
          topic: 'ci-cd-pipelines',
          topicLabel: 'CI/CD Pipelines',
          start: '2025-08-20T00:00:00.000Z',
        },
      ],
    },
    {
      email: 'iris.dang@example.com',
      username: 'iris.dang',
      name: 'Iris Dang',
      avatar: FALLBACK_SRC.AVATAR,
      trainings: [
        {
          id: 'trainee-training-006',
          topic: 'graphql-api-design',
          topicLabel: 'GraphQL API Design',
          start: '2025-06-15T00:00:00.000Z',
        },
      ],
    },
    {
      email: 'jack.ly@example.com',
      username: 'jack.ly',
      name: 'Jack Ly',
      avatar: FALLBACK_SRC.AVATAR,
      trainings: [
        {
          id: 'trainee-training-007',
          topic: 'aws-cloud-practitioner',
          topicLabel: 'AWS Cloud Practitioner',
          start: '2025-07-01T00:00:00.000Z',
        },
        {
          id: 'trainee-training-008',
          topic: 'system-design',
          topicLabel: 'System Design Fundamentals',
          start: '2025-10-10T00:00:00.000Z',
        },
      ],
    },
  ],
  daysOff: 12,
} satisfies EmployeeYearInReview;
